import React, { useState } from "react";
import PropTypes from "prop-types";
import FsLightbox from "fslightbox-react";
import * as theme4Styles from "../../scss/theme4.module.scss";

const Media = ({ pictures, watermark }) => {
  const [toggler, setToggler] = useState(false);
  const [slide, setSlide] = useState(0);

  const handleImageOnClick = (toggler, slide) => {
    setToggler(!toggler);
    setSlide(slide);
  };

  const sources = pictures.map((picture) =>
    watermark ? picture.watermark_url : picture.image_url
  );

  return (
    <div className={`${theme4Styles.detailsImagesC}`}>
      <FsLightbox
        type="image"
        toggler={toggler}
        slide={slide}
        sources={sources}
      />
      <div className={theme4Styles.detailsImages}>
        {pictures.slice(0, 3).map((picture, i) => {
          return (
            <div
              className={`${theme4Styles.thumbView}`}
              key={i}
              onClick={() => handleImageOnClick(toggler, i + 1)}
            >
              <img alt="image" src={picture.image_url} />
            </div>
          );
        })}
        {(() => {
          if (pictures.length == 4) {
            return (
              <div
                className={`${theme4Styles.thumbView}`}
                onClick={() => handleImageOnClick(toggler, 4)}
              >
                <img alt="image" src={pictures[3].image_url} />
              </div>
            );
          } else if (pictures.length > 4) {
            return (
              <div
                className={`${theme4Styles.thumbView}`}
                onClick={() => handleImageOnClick(toggler, 4)}
              >
                <img alt="image" src={pictures[3].image_url} />
                {/* <a href="#" onClick={e => e.preventDefault()} className={theme4Styles.total}>
                                        <span>View All</span>
                                    </a> */}
              </div>
            );
          }
        })()}
        <div className={theme4Styles.clear}></div>
      </div>
    </div>
  );
};

Media.propTypes = {
  pictures: PropTypes.array.isRequired,
  watermark: PropTypes.bool,
};

export default Media;
